<template>
  <div class="service">
    <div id="service" class="anchor"></div>
    <p class="enterprise-title">服务定制</p>
    <div class="service-top">
      <div class="service-top-title">
        精选定制服务，解决企业难题，让您办公无忧
      </div>
      <div class="service-top-content">
        <div
          class="service-top-process"
          v-for="(item, index) in serviceProcess"
          :key="index"
        >
          <div class="service-top-content-left">
            <div class="service-top-content-circle">
              <div class="service-top-content-block">
                <icon :type="item.icon"></icon>
              </div>
            </div>
            <p>{{ item.text }}</p>
          </div>
          <div
            class="service-top-content-right"
            :class="{
              'service-top-content-right-hide':
                index === serviceProcess.length - 1,
            }"
          >
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="service-bottom">
      <div
        class="service-bottom-card"
        v-for="(item, index) in personalService"
        :key="index"
      >
        <img :src="cardImg(item.img)" alt="" />
        <div class="service-bottom-content">
          <div class="service-bottom-content-title">{{ item.title }}</div>
          <div class="service-bottom-content-tips">{{ item.tips }}</div>
          <lr-link
            class="service-bottom-content-button"
            :class="`btn-color-${item.btnColor}`"
            :to="item.url"
            @click="reportClick(item.dw)"
            >立即定制</lr-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    serviceProcess: {
      type: Array,
      default: () => [
        {
          text: '需求填写',
          icon: 'iconicon_demand',
        }
      ],
    },
    personalService: {
      type: Array,
      default: () => [
        {
          title: '培训课程定制',
          tips: '量身定制人才培养方案',
          img: 'training',
          url: 'https://f.wps.cn/w/OHjz9gY2/?chan=pc_company_made',
          dw: 'traincustom',
          btnColor: 'green',
        }
      ],
    },
  },
  methods: {
    cardImg(img) {
      return require(`@/assets/image/enterprise/service/${img}.png`);
    },
    reportClick(click) {
      this.$collect.enterpriseHomepageClick({ click, area: 'service' });
    },
  },
};
</script>
<style lang="scss" scoped>
.service {
  &-top {
    height: 319px;
    background-color: #fafbfd;
    &-process {
      display: flex;
    }
    &-title {
      padding: 60px 0;
      font-size: 24px;
      font-weight: 600;
      color: #222226;
      line-height: 33px;
      text-align: center;
    }
    &-content {
      display: flex;
      &-left {
        width: 153px;
        text-align: center;
        > p {
          font-size: 16px;
          font-weight: 400;
          color: #222226;
          user-select: none;
        }
      }
      &-circle {
        width: 84px;
        height: 84px;
        border: 1px solid #979797;
        border-radius: 50%;
        display: inline-block;
        margin-bottom: 10px;
        position: relative;
      }
      &-block {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .icon {
          font-size: 37px;
        }
      }
      &-right {
        height: 84px;
        display: flex;
        align-items: center;
        margin-right: 8px;
        > span {
          width: 6px;
          height: 6px;
          background-color: #e8e8e8;
          display: inline-block;
          margin-right: 7px;
          border-radius: 50%;
          &:nth-child(3) {
            margin-right: 0;
          }
        }
        &-hide {
          display: none;
        }
      }
    }
  }
  &-bottom {
    display: flex;
    margin-top: 44px;
    justify-content: space-between;
    user-select: none;
    &-card {
      width: 356px;
      height: 150px;
      display: flex;
      background: #ffffff;
      position: relative;
      > img {
        width: 100%;
        height: 100%;
      }
    }
    &-content {
      width: 100%;
      height: 100%;
      position: absolute;
      padding: 25px 20px;
      &-title {
        font-size: 22px;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
      }
      &-tips {
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 16px;
        margin: 8px 0 20px;
      }
      &-button {
        display: block;
        width: 90px;
        height: 26px;
        border-radius: 18px;
        background-color: #ffffff;
        line-height: 26px;
        text-align: center;
        cursor: pointer;
        font-size: 12px;
        &:hover{
          opacity: 0.9;
        }
      }
    }
  }
}
.btn-color {
  &-green {
    color: #10ba76;
  }
  &-red {
    color: #e74a55;
  }
  &-purple {
    color: #5458e4;
  }
}
</style>
